(function () {
    'use strict';

    angular
		.module('skillsApp')
		.controller('AdminEmployeesController', AdminEmployeesController);

    function AdminEmployeesController($scope, $state, $stateParams, $translate, logger, config, notifyingService, dataService, jsReportService) {
        var vm = this;
        var _lazyLoadQualities = _.debounce(loadQualities, 300);
        
        var columnDefs = [
            {
                displayName: $translate.instant('skill'),
                name: 'actionName',
                minWidth: 200,
                enableColumnMenu: false
            },
            {
                displayName: $translate.instant('department'),
                name: 'departmentName',
                minWidth: 150,
                enableColumnMenu: false,
                visible: !config.settings.onlyAssignToFunctions
            },
            {
                displayName: $translate.instant('function'),
                name: 'functionName',
                enableColumnMenu: false,
                minWidth: 150
            },
            {
                displayName: $translate.instant('progress'),
                name: 'progress',
                cellTemplate: '/app/templates/common/userquality-progress-cell.tpl.html',
                enableColumnMenu: false,
                width: 150,
                enableFiltering: false
            },
            {
                displayName: $translate.instant('expiry_date'),
                name: 'dateOfExpiry',
                cellTemplate: '/app/templates/common/date-of-expiry-cell.tpl.html',
                width: 150,
                enableColumnMenu: false,
                enableFiltering: false
            },
            {
                displayName: '',
                name: 'buttons',
                cellTemplate: '/app/templates/common/grid-buttons-edit.tpl.html',
                width: 80,
                enableColumnMenu: false,
                enableFiltering: false
            }
        ];

        vm.gridOptions = {
            enableFiltering: true,
            appScopeProvider: vm,
            onRegisterApi: function (gridApi) {
                vm.gridOptions.gridApi = gridApi;
            },
            columnDefs: columnDefs
        };
        
        notifyingService.subscribe($scope, 'userquality-updated', function (event, args) {
            if (!vm.selectedUserQuality) return;
            if (args.id !== vm.selectedUserQuality.id) return;
            loadQualities();
        });

        $scope.$watch('vm.filterValues', function (n, o) {
            if (o === n) return;
            loadQualities();
        }, true);

        $scope.$watch('vm.selectedUser', function (n, o) {
            if (o === n) return;
            loadQualities();
        });

        vm.clearUserInfo = clearUserInfo;
        vm.downloadExcel = downloadExcel;
        vm.downloadPdf = downloadPdf;
        vm.editEntity = editEntity;
        vm.isCurrentState = isCurrentState;
        vm.loadQualities = loadQualities;

        vm.onSelectUser = onSelectUser;
        vm.searchUsers = searchUsers;

        function _downloadReport(type) {
            var reportInfo = {
                employeeName: vm.selectedUser.name,
                filterValues: vm.filterValues,
                onlyAssignToFunctions: config.settings.onlyAssignToFunctions
            };
            var items = vm.gridOptions.data;

            return jsReportService.getEmployeesUserQualitiesReport(type, reportInfo, items);
        }

        function clearUserInfo() {
            vm.selectedUserInfo = null;
        }

        function downloadExcel() {
            return _downloadReport('xlsx');
        }

        function downloadPdf() {
            return _downloadReport('pdf');
        }

        function editEntity(entity) {
            vm.selectedUserQuality = entity;
            $state.go($state.current.name + '.userquality', { id: entity.id });
        }
        
        function isCurrentState() {
            return $state.is('app-main.admin-employees');
        }
        
        function loadQualities() {
            vm.gridOptions.data = [];

            if (!vm.selectedUser) return;

            var params = {
                idString: vm.selectedUser.idString,
                assignedTo: vm.filterValues.assignedTo,
                status: vm.filterValues.status,
                connected: vm.filterValues.connected,
                doesNotApply: vm.filterValues.doesNotApply
            };

            return dataService.getUserQualities(params).then(userQualities => {
                // todo: sort by actionname, departmentname, rolename
                vm.gridOptions.data = userQualities;
                vm.gridOptions.gridApi.core.handleWindowResize();
            });
        }

        function onSelectUser() {
            vm.selectedUser = angular.copy(vm.userSearch);
            delete vm.userSearch;
        }

        function searchUsers(search) {
            vm.isLoading = true;

            return dataService
                .searchUserQualitiesUsers(search)
                .then(response => {
                    vm.isLoading = false;
                    return _.map(response.results, user => { return { name: user.employeeName, type: user.logOnName, idString: user.studentIdString }; });
                });
        }
    }
})();